export default function ($scope, $location, $window, $anchorScroll, AuthenticationService, FlashService, Restangular, CifService) {
    if(GetData().currentUser)
        $location.path('/account');

    $scope.menu = function() {
        $('html').toggleClass("nav-open");
    };
    $scope.year = new Date().getFullYear();

    var date = new Date();
    date.setFullYear(date.getFullYear()-18);
    $scope.maxdate = date;

    $scope.roles_list = {
        'patient' : 'ROLE_PATIENT',
        'prescriber' : 'ROLE_PRENSCRIPTOR',
        'company' : 'ROLE_COMPANY'
    };

    Restangular
        .allUrl('states', AuthenticationService.Api.Public+'states')
        .getList({_filters: '{"country":"' + 1 + '"}', _sortDir: "ASC", _sortField: "name"})
        .then(data => {
            data = data.data ? data.data : data;

            $scope.states = data;
            $scope.apply();
        });

    Restangular
        .allUrl('prescriberTypes', AuthenticationService.Api.Public+'prescriberTypes')
        .getList({_sortDir: "ASC", _sortField: "description"})
        .then(data => {
            data = data.data ? data.data : data;

            $scope.prescriberTypes = data;
            $scope.updatePrescriptorType($scope.$root.current_language);

            $scope.apply();
        });

    Restangular
        .allUrl('countries', AuthenticationService.Api.Public+'countries')
        .getList({ _sortDir: "DESC", _sortField: "sticky"})
        .then(data => {
            data = data.data ? data.data : data;

        $scope.countries = data;
        $scope.apply();
    });

    $scope.$watch('email', function(){
        $scope.form.email.$setValidity('exists', true);
    });

    $scope.$watch('username', function(){
        $scope.form.username.$setValidity('exists', true);
    });

    $scope.$watch('plainPassword', function(){
        $scope.form.plainPassword.$setValidity('low', true);
    });

    $scope.$watch('confirm', function(){
        $scope.form.confirm.$setValidity('same', true);
    });

    $scope.$root.$watch('current_language', function(new_value){
        $scope.updatePrescriptorType(new_value);
    });

    $scope.$watch('cif', function(value){
        $scope.form.cif.$setValidity('exists', true);

        if (!CifService.Validate(value)) {
            $scope.form.cif.$setValidity('invalid', false);
        }else{
            $scope.form.cif.$setValidity('invalid', true);
        }
    });

    $scope.updatePrescriptorType =  function(language){
        if(!$scope.prescriberTypes || !language) return false;

        $scope.prescriberTypes.map(function(type){
            if(type['description_'+language])
                type.label = type['description_'+language];
            else
                type.label = type['description'];

            return type;
        })
    }

    $scope.register = function () {
        $scope.dataLoading = true;

        AuthenticationService.PublicLogin(function(response){
            if(response.status == "200") {

                var birthday = null;

                if($scope.birthday){
                    var date = new Date($scope.birthday);
                    birthday = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + (date.getDate())).slice(-2);
                }

                var userData = {
                    username : $scope.username,
                    email : $scope.email,
                    plainPassword : $scope.plainPassword,
                    confirm: $scope.confirm,
                    name : $scope.name ? $scope.name : $scope.company,
                    surname : $scope.surname,
                    roles : $scope.roles_list[$scope.type],
                    birthday: birthday,
                    prescriberType: $scope.precriberType,
                    city: $scope.city,
                    address: $scope.address,
                    postalCode: $scope.postalCode,
                    state: $scope.state,
                    cif: $scope.cif,
                    country: $scope.country,
                    stateName: $scope.stateName
                };

                if(!birthday)
                    delete userData.birthday;

                Restangular
                    .all('user')
                    .post(userData)
                    .then(data => {

                        FlashService.Success("CREATED_CHECK_YOUR_EMAIL");

                        $scope.dataLoading = false;

                        $location.path('/login');

                    }, error => {
                        $scope.dataLoading = false;

                        $anchorScroll("navbar");
                        FlashService.Error("MALFORMET_DATA");

                        error.data.fields.forEach(function(field, index){
                            if(field.property_path == 'email' || field.property_path == 'username'){
                                $scope.form[field.property_path].$setValidity('exists', false);
                            }

                            if(field.property_path == 'confirm'){
                                $scope.form[field.property_path].$setValidity('same', false);
                            }

                            if(field.property_path == 'plainPassword'){
                                $scope.form[field.property_path].$setValidity('low', false);
                            }
                        });

                        form.$invalid = false;

                    });
            }else{
                FlashService.Error("Internal Error")
            }
        }, true);

    };
};


/** WEBPACK FOOTER **
 ** ./js/theme/register/controller.js
 **/